import axios from "axios";

const InitialState = {
  counterBuildings: null,
  counterRooms: null,
  counterResources: null,
  countTypes: null
};

const MANAGE_OOP_RESOURCES_MAT_TECH_INDEX_TYPE = "MANAGE_OOP_RESOURCES_MAT_TECH_INDEX_TYPE";

function counterBuildingsGetRequest() {
  return axios("/work/api/dashboard/counter/manage-resources-resources-buildings", {
    headers: {'Accept': 'application/json'},
  });
}

function counterRoomsGetRequest() {
  return axios("/work/api/dashboard/counter/manage-resources-resources-rooms", {
    headers: {'Accept': 'application/json'},
  });
}

function counterResourcesGetRequest() {
  return axios("/work/api/dashboard/counter/manage-resources-resources-resources", {
    headers: {'Accept': 'application/json'},
  });
}

function counterTypesGetRequest() {
  return axios("/work/api/dashboard/counter/manage-resources-resources-types", {
    headers: {'Accept': 'application/json'},
  });
}



function counterBuildingsReceive(item) {
  return {
    type: MANAGE_OOP_RESOURCES_MAT_TECH_INDEX_TYPE,
    reduce: (state) => {
      return {
        ...state,
        counterBuildings: item
      }
    }
  }
}

function counterRoomsReceive(item) {
  return {
    type: MANAGE_OOP_RESOURCES_MAT_TECH_INDEX_TYPE,
    reduce: (state) => {
      return {
        ...state,
        counterRooms: item
      }
    }
  }
}

function counterResourcesReceive(item) {
  return {
    type: MANAGE_OOP_RESOURCES_MAT_TECH_INDEX_TYPE,
    reduce: (state) => {
      return {
        ...state,
        counterResources: item
      }
    }
  }
}

function counterTypesReceive(item) {
  return {
    type: MANAGE_OOP_RESOURCES_MAT_TECH_INDEX_TYPE,
    reduce: (state) => {
      return {
        ...state,
        counterTypes: item
      }
    }
  }
}


export function counterBuildingsQuery() {
  return (dispatch) => {
    return counterBuildingsGetRequest()
      .then(response => {
        dispatch(counterBuildingsReceive(response.data))
      }, err => {
        dispatch(counterBuildingsReceive(null))
      })
  }
}

export function counterRoomsQuery() {
  return (dispatch) => {
    return counterRoomsGetRequest()
      .then(response => {
        dispatch(counterRoomsReceive(response.data))
      }, err => {
        dispatch(counterRoomsReceive(null))
      })
  }
}

export function counterResourcesQuery() {
  return (dispatch) => {
    return counterResourcesGetRequest()
      .then(response => {
        dispatch(counterResourcesReceive(response.data))
      }, err => {
        dispatch(counterResourcesReceive(null))
      })
  }
}

export function counterTypesQuery() {
  return (dispatch) => {
    return counterTypesGetRequest()
      .then(response => {
        dispatch(counterTypesReceive(response.data))
      }, err => {
        dispatch(counterTypesReceive(null))
      })
  }
}


export function reducer(state = InitialState, action) {
  if (action.type === MANAGE_OOP_RESOURCES_MAT_TECH_INDEX_TYPE) {
    return action.reduce(state)
  }
  return state;
}
